<template>
	<el-descriptions style="margin-top: 20px;margin-bottom: 20px;" size="mini" class="margin-top" title="申请信息" border>
		<el-descriptions-item v-if="biao.louceng">
			<template slot="label">
				产品名
			</template>
			{{biao.louceng}}
		</el-descriptions-item>
		<el-descriptions-item v-if="biao.beizhu">
			<template slot="label">
				详细信息
			</template>
			{{biao.beizhu}}
		</el-descriptions-item>
	</el-descriptions>
</template>

<script>
	export default {
		data() {
			return {

			}
		},
		computed: {
			cjtypes() {

				return this.biao.cjtypes;
			}

		},
		watch: {
			biao() {

			}
		},
		props: ["biao"],
		created() {

		}
	}
</script>

<style>
</style>